import styled from "styled-components";
import { Card } from "react-bootstrap";

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--secondary-text);
  margin-bottom: 8px;
`;

export const TestCard = styled(Card)`
  border: 1px solid var(--th-border-color);
  border-radius: 10px;
`;

export const VariantColumn = styled.div`
  border: 1px solid ${({ $winner }) => ($winner ? "#198754" : "#e6e8eb")};
  border-radius: 10px;
  padding: 14px 16px;
  height: 100%;
  background: ${({ $winner }) => ($winner ? "#f3fbf6" : "#fff")};
`;

export const VariantLabel = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 14px;
  span.chip {
    display: inline-block;
    min-width: 26px;
    text-align: center;
    padding: 2px 8px;
    border-radius: 6px;
    color: #fff;
    background: ${({ $variant }) => ($variant === "B" ? "#0d6efd" : "#6c757d")};
  }
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $cols }) => $cols || 3}, minmax(0, 1fr));
  gap: 10px;
  margin-top: 12px;
`;

export const Stat = styled.div`
  background: #f8f9fb;
  border-radius: 8px;
  padding: 10px 12px;
  .label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--secondary-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .value {
    font-size: ${({ $big }) => ($big ? "26px" : "20px")};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ $color }) => $color || "#212529"};
  }
  .sub {
    font-size: 12px;
    color: var(--secondary-text);
  }
`;

export const TextValue = styled.div`
  font-family: inherit;
  font-size: 14px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px dashed #ced4da;
  white-space: pre-wrap;
  word-break: break-word;
  min-height: 38px;
`;

export const FormMock = styled.div`
  margin-top: 12px;
  border: 1px solid #e6e8eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  font-size: 11px;
  color: #212529;
  .bar {
    background: #198754;
    color: #fff;
    padding: 6px 10px;
    font-weight: 600;
  }
  .bar small {
    display: block;
    font-weight: 400;
    opacity: 0.9;
  }
  .body {
    padding: 10px;
  }
  .headline {
    font-weight: 700;
    font-size: 12px;
  }
  .sub {
    color: #6c757d;
    margin-bottom: 8px;
  }
  .field {
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 4px 8px;
    margin-bottom: 5px;
    color: #6c757d;
    background: #fff;
  }
  .field b {
    color: #212529;
    margin-right: 4px;
  }
  .social {
    font-size: 10px;
    color: #495057;
    margin: -4px 0 6px;
  }
  .rating {
    font-size: 10px;
    text-align: center;
    margin-top: 4px;
  }
  .rating .stars {
    color: #f5b301;
    letter-spacing: 1px;
  }
  .btn-mock {
    margin-top: 6px;
    background: #e15d3a;
    color: #fff;
    border-radius: 4px;
    padding: 6px;
    text-align: center;
    font-weight: 700;
  }
  .btn-sub {
    text-align: center;
    color: #6c757d;
    margin-top: 3px;
    min-height: 12px;
  }
  .hl {
    outline: 2px solid #ffc107;
    outline-offset: 1px;
    border-radius: 3px;
  }
`;

export const TimelineList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;
  font-size: 12px;
  li {
    display: flex;
    gap: 10px;
    padding: 4px 0;
    border-bottom: 1px dashed #eceff1;
  }
  li:last-child {
    border-bottom: none;
  }
  .when {
    min-width: 120px;
    color: var(--secondary-text);
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 36px 16px;
  color: var(--secondary-text);
  .title {
    font-weight: 600;
    color: #212529;
    margin-bottom: 4px;
  }
`;
